import request from '@/utils/request'
//影视上方广告
export function movie_top(data) {
    return request({
        url: '/api/ad/movie_top',
        method: 'get',
        params: data
    })
}
//热门专题
export function special_index(data) {
    return request({
        url: '/api/v2/special/index',
        method: 'post',
        params: data
    })
}
// 分类
export function hot_list(data) {
    return request({
        url: '/api/v2/special/hot_list',
        method: 'post',
        params: data
    })
}
//专题分类影视
export function special_video(data) {
    return request({
        url: '/api/special/video',
        method: 'post',
        params: data
    })
}
//专题更多
export function special_more(data) {
    return request({
        url: '/api/v2/special/more',
        method: 'post',
        params: data
    })
}
//专题女优
export function special_av(data) {
    return request({
        url: '/api/v2/special/av',
        method: 'post',
        params: data
    })
}
//电影详情
export function video_detail(data) {
    return request({
        url: '/api/video/detail',
        method: 'post',
        params: data
    })
}
// 影视详情滚动公告
export function radio_index(data) {
    return request({
        url: '/api/radio/index',
        method: 'post',
        params: data
    })
}
//评分的百分比
export function rate_show(data) {
    return request({
        url: '/api/rate/show',
        method: 'post',
        params: data
    })
}
//综合评分
export function rate_index(data) {
    return request({
        url: '/api/rate/index',
        method: 'post',
        params: data
    })
}
//用户评分
export function rate_create(data) {
    return request({
        url: '/api/rate/create',
        method: 'post',
        params: data
    })
}
//用户是否评分
export function rate_scoring(data) {
    return request({
        url: '/api/rate/scoring',
        method: 'post',
        params: data
    })
}
//影视详情中部广告
export function ad_detail(data) {
    return request({
        url: '/api/ad/detail',
        method: 'post',
        params: data
    })
}
//当前电影推荐
export function video_recommend(data) {
    return request({
        url: '/api/video/recommend',
        method: 'post',
        params: data
    })
}
//观看次数
export function user_view(data) {
    return request({
        url: '/api/user_view/save',
        method: 'post',
        params: data
    })
}
//新广告
export function play_intermediate(data) {
  return request({
    url: '/api/v2/video/middle_adv_list',
    method: 'post',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/video.js